/*
 *   Copyright (c) 2022 nVipani Technology Solutions Private Limited.
 *   All rights reserved.
 */
import { Injectable } from "@angular/core";
import { API_PATH } from "../../environments/config";
import { HttpClient, HttpParams } from "@angular/common/http";
import { OrderByPipe } from "node_modules/valuchaincommon/shared-components/order-by/order-by.pipe";
import { environment } from "src/environments/environment";
import { SlotService } from "valuchaincommon/slot/slot-service/slot.service";
import { UserService } from "valuchaincommon/common-services/user/user.service";

@Injectable({
  providedIn: "root",
})
export class OrderService {
  public totalOrdersList;
  public totalIndex;
  public totalOrdersCount;
  public searchText;
  public currentOrderData;
  public currentPage;
  public currentTab;
  public currentAppliedFilters;
  public currentSort;
  public currentSortType;
  public currentPageNoAll;
  public tabIndex = 0;
  public whiteshopConfig;
  public autoScroll;
  public isContact = false;
  public cancelledOrderNumber;
  public partiallyCancelledQty;
  public cancelledOrderId;
  public orderStatusView;
  public isBackFromOrderDetailed = false;
  public lastSeenIndex;
  public wholeOrderObject;
  public orderStatus = [
    [
      "Pending",
      "Confirmed",
      "Cancelled",
      // "Fulfilled",
      "Picked",
      "In Transit",
      "Ready To Pick",
      "Shipped",
      "Out For Delivery",
      "Delivered",
      // "Completed",
    ],
    [
      "Pending",
      "Confirmed",
      "Cancelled",
      // "Fulfilled",
      "Picked",
      "In Transit",
      "Ready To Pick",
      "Shipped",
      "Out For Delivery",
      "Delivered",
    ],
    ["Delivered", "Picked", "Cancelled"],
  ];
  timeLineList = [
    "Last 30 Days",
    "Last 3 Months",
    "Last 6 Months",
    (new Date().getFullYear() - 1).toString(),
    new Date().getFullYear().toString(),
  ];
  orderTypeList = {
    "All Orders": [],
    Delivered: ["Delivered"],
    Picked: ["Picked"],
    "Not Yet Shipped": ["Confirmed", "Ready To Pick"],
    Cancelled: ["Cancelled"],
  };
  isOrderApiGoingOn = false;
  constructor(
    private http: HttpClient,
    public slotService: SlotService,
    public vcUserService: UserService
  ) {}
  URL = {
    appointmentOrder: "/appointmentOrder",
    getOrderActivities: "/getOrderActivities",
  };
  prodServerUrl = environment.server;

  getOrderList(
    page,
    limit = 10,
    businessUnitId?,
    searchText?,
    fromDate?,
    toDate?,
    populateInventoryData?,
    isStatus?,
    isTab?,
    sortType?,
    sortItem?
  ) {
    let httpParams = new HttpParams();
    httpParams = httpParams
      .set("page", page.toString())
      .set("limit", limit.toString());
    if (businessUnitId) {
      httpParams = httpParams.set("businessUnitId", businessUnitId);
    }
    if (searchText) {
      httpParams = httpParams.set("searchText", searchText);
    }
    if (fromDate) {
      httpParams = httpParams.set(
        "fromDate",
        this.slotService.stringDateFormat(fromDate)
      );
    }
    if (toDate) {
      httpParams = httpParams.set(
        "toDate",
        this.slotService.stringDateFormat(toDate)
      );
    }
    if (populateInventoryData) {
      httpParams = httpParams.set("populateInventoryData", "true");
    }
    if (isStatus) {
      httpParams = httpParams.set("status", isStatus.join());
    }
    if (isTab) {
      httpParams = httpParams.set("tab", isTab === 2 ? "true" : "false");
    }
    if (sortType) {
      httpParams = httpParams.set("sortType", sortType);
    }
    if (sortItem) {
      httpParams = httpParams.set("sortItem", sortItem);
    }
    return this.http.get<any>(`${API_PATH.apis.getAppointmentsOrders}`, {
      params: httpParams,
    });
  }
  getContactOrderList(
    contactId,
    page,
    limit = 10,
    businessUnitId?,
    searchText?,
    fromDate?,
    toDate?,
    populateInventoryData?,
    isStatus?,
    isTab?,
    sortType?,
    sortItem?
  ) {
    let httpParams = new HttpParams();
    httpParams = httpParams
      .set("page", page.toString())
      .set("limit", limit.toString());
    if (contactId) {
      httpParams = httpParams.set("contactId", contactId);
    }
    if (businessUnitId) {
      httpParams = httpParams.set("businessUnitId", businessUnitId);
    }
    if (searchText) {
      httpParams = httpParams.set("searchText", searchText);
    }
    if (fromDate) {
      httpParams = httpParams.set(
        "fromDate",
        this.slotService.stringDateFormat(fromDate)
      );
    }
    if (toDate) {
      httpParams = httpParams.set(
        "toDate",
        this.slotService.stringDateFormat(toDate)
      );
    }
    if (populateInventoryData) {
      httpParams = httpParams.set("populateInventoryData", "true");
    }
    if (isStatus) {
      httpParams = httpParams.set("status", isStatus.join());
    }
    if (isTab) {
      httpParams = httpParams.set("tab", isTab === 2 ? "true" : "false");
    }
    if (sortType) {
      httpParams = httpParams.set("sortType", sortType);
    }
    if (sortItem) {
      httpParams = httpParams.set("sortItem", sortItem);
    }
    return this.http.get<any>(`${API_PATH.apis.getContactOrders}`, {
      params: httpParams,
    });
  }

  createOrder(data) {
    return this.http.post<any>(API_PATH.apis.createAppointmentOrder, data);
  }
  generateReport(data) {
    return this.http.post<any>(API_PATH.apis.orderReport, data);
  }
  getOrder(id) {
    const httpParams = new HttpParams().set("orderId", id.toString());
    return this.http.get<any>(this.prodServerUrl + this.URL.appointmentOrder, {
      params: httpParams,
    });
  }

  logActivity(data) {
    return this.http.put<any>(API_PATH.apis.logActivity, data);
  }

  updateSellerStatus(data) {
    return this.http.put<any>(API_PATH.apis.updateSellerStatus, data);
  }

  getOrderActivities(orderId, isCustomOrder?) {
    let httpParams = new HttpParams().set("orderId", orderId.toString());
    if (isCustomOrder) {
      httpParams = httpParams.set("isCustomOrder", isCustomOrder);
    }
    return this.http.get<any>(
      this.prodServerUrl + this.URL.getOrderActivities,
      {
        params: httpParams,
      }
    );
  }

  cancelOrder(data) {
    return this.http.put<any>(API_PATH.apis.cancelOrder, data);
  }

  sortByProducts(productList) {
    const instantProducts = productList.filter(
      (each) => !each.inventoryGroup && each.numberOfUnits
    );

    return OrderByPipe.prototype
      .transform(
        productList.filter(
          (each) =>
            each.inventoryGroup &&
            each.inventoryGroup.name &&
            each.numberOfUnits
        ),
        ["inventoryGroup", "name"]
      )
      .concat(instantProducts);
  }

  setupOrderImages(orderList) {
    orderList.forEach((element, index) => {
      orderList[index]["images"] = [];
      if (element.products?.length) {
        element.products.forEach((eachProduct, eachProductIndex) => {
          if (
            (eachProduct.cancellationStatus?.status !== "Cancelled" &&
              !eachProduct.deleted) ||
            element.order?.status === "Cancelled"
          ) {
            if (
              eachProduct.virtualProductConfigurations?.[0]?.images?.[0]
                ?.originalImageURL
            ) {
              orderList[index]["images"].push(
                this.vcUserService.getImageURL(
                  eachProduct.virtualProductConfigurations[0].images[0]
                    .originalImageURL
                )
              );
            } else if (
              eachProduct.inventoryGroup?.gallery?.images?.length &&
              eachProduct.inventoryGroup.gallery.images[0] &&
              eachProduct.inventoryGroup.gallery.images[0].originalImageURL
            ) {
              orderList[index]["images"].push(
                this.vcUserService.getImageURL(
                  eachProduct.inventoryGroup.gallery.images[0].originalImageURL
                )
              );
            } else if (
              eachProduct.inventory?.gallery?.images?.length &&
              eachProduct.inventory.gallery.images[0] &&
              eachProduct.inventory.gallery.images[0].originalImageURL
            ) {
              orderList[index]["images"].push(
                this.vcUserService.getImageURL(
                  eachProduct.inventory.gallery.images[0].originalImageURL
                )
              );
            } else if (
              eachProduct.images?.length &&
              eachProduct.images[0] &&
              eachProduct.images[0].originalImageURL
            ) {
              orderList[index]["images"].push(
                this.vcUserService.getImageURL(
                  eachProduct.images[0].originalImageURL
                )
              );
            } else {
              orderList[index]["images"].push("assets/images/itemmaster.svg");
            }
          }
        });
      }
    });
    return orderList;
  }
  addMonths(input, months) {
    const date = new Date(input);
    date.setDate(1);
    date.setMonth(date.getMonth() + months);
    date.setDate(
      Math.min(
        input.getDate(),
        new Date(date.getFullYear(), date.getMonth() + 1, 0).getDate()
      )
    );
    return date;
  }
  getConsumerFilterObject(filters, isConsumer) {
    if (isConsumer) {
      filters.status = this.orderTypeList[filters.orderType];
      let newDate = new Date();
      switch (this.timeLineList[filters.timeLine]) {
        case "Last 30 Days": {
          filters.toDate = "";
          filters.fromDate = this.addMonths(newDate, -1);
          break;
        }
        case "Last 3 Months": {
          filters.toDate = "";
          filters.fromDate = this.addMonths(newDate, -3);
          break;
        }
        case "Last 6 Months": {
          filters.toDate = "";
          filters.fromDate = this.addMonths(newDate, -6);
          break;
        }
        default: {
          if (filters.timeLine === -1) {
            filters.fromDate = "";
            filters.toDate = "";
          } else {
            filters.toDate =
              new Date() <
              new Date(parseInt(this.timeLineList[filters.timeLine]), 11, 31)
                ? ""
                : new Date(
                    parseInt(this.timeLineList[filters.timeLine]),
                    11,
                    31
                  );
            filters.fromDate = new Date(
              parseInt(this.timeLineList[filters.timeLine]),
              0,
              1
            );
          }
          break;
        }
      }
      return filters;
    } else {
      return filters;
    }
  }

  getOrderById(data) {
    return this.http.get<any>(API_PATH.apis.orderByID + "/" + data);
  }

  updateOrder(data) {
    return this.http.put<any>(API_PATH.apis.orderByID + "/" + data._id, data);
  }

  getDeliverySlots() {
    return this.http.get<any>(
      this.prodServerUrl + API_PATH.apis.getDeliverySlots
    );
  }
}
